import React from 'react';

const VideoLoop = () => {
  return (
    <div className="relative w-full min-h-[480px] md:min-h-[560px] flex items-center">
      <picture>
        <source srcSet="/images/hero.webp" type="image/webp" />
        <img
          src="/images/video1.png"
          alt="Servicios de limpieza y mantenimiento en Querétaro"
          className="absolute inset-0 w-full h-full object-cover"
          loading="eager"
        />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/35"></div>
      <div className="relative z-10 w-full flex flex-col items-center justify-center px-6 py-16 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white drop-shadow-lg max-w-3xl leading-tight">
          Servicios de Limpieza Profunda y Mantenimiento en Querétaro
        </h1>
        <p className="mt-4 text-lg md:text-xl text-white/80 max-w-xl">
          Casas, oficinas y negocios — expertos listos para ti
        </p>
        <a
          href="https://wa.me/message/WNVVW57KVZGPP1?src=qr"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-full transition-colors shadow-lg text-lg"
        >
          Solicitar cotización
        </a>
      </div>
    </div>
  );
};

export default VideoLoop;
